import { type EmailType } from '/@/common/email/api'
import { createModal } from '/@/core/elements/modal'

export interface GenericSendEmailModalData {
  emailType: EmailType | null
  id: string | null
  imageUrl: string | null
  title: string | null
  to: string | null
  hideTo: boolean
  showFrom: boolean
  multiple: boolean
  successMessage: string
  onSuccess: (() => void) | null
}

const { api, component } = createModal<GenericSendEmailModalData>(
  'GenericSendEmailModal',
  () => import('./GenericSendEmailModal.vue'),
  {
    emailType: null,
    id: null,
    imageUrl: null,
    title: null,
    to: null,
    hideTo: false,
    showFrom: false,
    multiple: false,
    successMessage: 'Congrats! Your email was sent.',
    onSuccess: null,
  },
)

export const useGenericSendEmailModal = api
export default component
